import React from "react";
import { useStaticQuery, Link, graphql } from "gatsby";
import { NavWrapper } from "../elements";

export const Nav = () => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: {eq: "logo.png"}) {
        publicURL
      }
    }
  
  `)

  const styleLink = {
    textDecoration: "none",
    color: "#000000",
    fontSize: '1.5rem',
    padding: "3px 12px",
    borderRadius: "3px"
  }
  return (
    <NavWrapper>
      <Link to="/" style={styleLink}>
        <img src={data.logo.publicURL} alt="my logo"/>
      </Link>
    </NavWrapper>
  )
}

//8dcaff
//4c96d7
//1761a0
//083b66
//01233f

//d19fe4
//a55fc1
//8a25b1
//650d88
//42075b

//f29898
//ec4c4c
//cf1717
//9a0606
//9a0606
